import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ILeadsParameters, ILeadsPartners, ILeadsSummary } from '../interfaces/leads-partners';

@Injectable({
    providedIn: 'root',
})
export class LeadsPartnersService {
    constructor(private _http: HttpClient) {}

    private serverUrl = 'https://' + window.location.host;
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}/leadspartners').replace(
        '{version}',
        this.version
    );

    getPartnerSourceCard(parameters: ILeadsParameters): Observable<ILeadsPartners[]> {
        return this._http.post<ILeadsPartners[]>(this._url + '/GetPartnerSourceCard/', parameters, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        });
    }

    getLeadSourceCard(parameters: ILeadsParameters): Observable<ILeadsPartners[]> {
        return this._http.post<ILeadsPartners[]>(this._url + '/GetLeadSourceCard/', parameters, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        });
    }

    getLeadsSummary(parameters: ILeadsParameters): Observable<ILeadsSummary[]> {
        return this._http.post<ILeadsSummary[]>(this._url + '/GetLeadsSummary/', parameters, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        });
    }

    getLeadsPullThru(parameters: ILeadsParameters): Observable<ILeadsSummary[]> {
        return this._http.post<ILeadsSummary[]>(this._url + '/GetLeadsPullThru/', parameters, {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        });
    }
}
